import { render, staticRenderFns } from "./ModalEditPartner.vue?vue&type=template&id=252c973a&scoped=true"
import script from "./ModalEditPartner.vue?vue&type=script&lang=js"
export * from "./ModalEditPartner.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ModalEditPartner.vue?vue&type=style&index=1&id=252c973a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252c973a",
  null
  
)

export default component.exports